import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AccountService } from 'src/app/services/http/business/account/account.service';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { TranslateService } from '@ngstack/translate';
import { SoundEnum } from 'src/app/enums/sound.enum';

@Component({
  selector: 'app-change-pass-direct',
  templateUrl: './change-pass-direct.component.html',
  styleUrls: ['./change-pass-direct.component.css']
})
export class ChangePassDirectComponent implements OnInit {

  form: FormGroup;

  constructor(
    private accountService: AccountService,
    private snackBar: SnackBarService,
    private translate: TranslateService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ChangePassDirectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.createForm();
  }


  createForm() {
    this.form = this.fb.group({
      NationalCode: [this.data.NationalCode],
      Password: [null, Validators.required],
      RePassword: [null, Validators.required]
    });
  }

  submit(data: any) {
    this.accountService.userForgetPassByAdmin(data).subscribe(() => {
      this.dialogRef.close();
      this.snackBar.OpenSnackBar(
        this.translate.get("success.changePass"),
        "ok",
        5000,
        SoundEnum.beep
      );
    })
  }


  onNoClick(): void {
    this.dialogRef.close();
  }


}
